var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450.187,
    height: 877.862,
    viewBox: "0 0 450.187 877.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "COQUE",
    transform: "translate(0.936 9.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6741",
    "data-name": "Group 6741",
    transform: "translate(5.077 808.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14656",
    "data-name": "Path 14656",
    d: "M248.86,1088.43s-3.087,35.33,6.317,43.736,32.967,7.187,32.967,7.187l-16.464-15.5s-9.42-3.974-10.887-22.3S248.86,1088.43,248.86,1088.43Z",
    transform: "translate(-248.375 -1087.751)",
    fill: "#475e6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14657",
    "data-name": "Path 14657",
    d: "M287.658,1088.43s3.087,35.33-6.317,43.736-32.967,7.187-32.967,7.187l16.464-15.5s9.42-3.974,10.887-22.3S287.658,1088.43,287.658,1088.43Z",
    transform: "translate(148.616 -1087.751)",
    fill: "#475e6a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1575",
    "data-name": "Rectangle 1575",
    transform: "translate(433.751 5.55) rotate(90)",
    fill: "none",
    stroke: "#475e6a",
    strokeWidth: 15.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 846.862,
    height: 419.187,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -7.75,
    y: -7.75,
    width: 862.362,
    height: 434.687,
    rx: 22.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6688",
    "data-name": "Group 6688",
    transform: "translate(9.975 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14655",
    "data-name": "Path 14655",
    d: "M17.593,0h59L35.059,23V407.593l42.986,20.773H17.593A17.593,17.593,0,0,1,0,410.773V17.593A17.593,17.593,0,0,1,17.593,0Z",
    transform: "translate(428.366) rotate(90)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6705",
    "data-name": "Group 6705",
    transform: "translate(153.557 17.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6691",
    "data-name": "Group 6691",
    transform: "translate(33.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6690",
    "data-name": "Group 6690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6689",
    "data-name": "Group 6689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14643",
    "data-name": "Path 14643",
    d: "M335.937,43.133a4.919,4.919,0,1,1,0-9.838h63.258a4.919,4.919,0,1,1,0,9.838Z",
    transform: "translate(-331.017 -33.295)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6704",
    "data-name": "Group 6704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6694",
    "data-name": "Group 6694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6693",
    "data-name": "Group 6693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6692",
    "data-name": "Group 6692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14644",
    "data-name": "Path 14644",
    d: "M319.784,43.133a4.919,4.919,0,1,1,4.918-4.92A4.925,4.925,0,0,1,319.784,43.133Z",
    transform: "translate(-314.866 -33.295)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6697",
    "data-name": "Group 6697",
    transform: "translate(18.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6696",
    "data-name": "Group 6696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6695",
    "data-name": "Group 6695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14645",
    "data-name": "Path 14645",
    d: "M328.407,43.133a4.919,4.919,0,1,1,4.918-4.92A4.925,4.925,0,0,1,328.407,43.133Z",
    transform: "translate(-323.487 -33.295)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6700",
    "data-name": "Group 6700",
    transform: "translate(131.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6699",
    "data-name": "Group 6699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6698",
    "data-name": "Group 6698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14646",
    "data-name": "Path 14646",
    d: "M382.346,43.133a4.919,4.919,0,1,1,4.918-4.92A4.925,4.925,0,0,1,382.346,43.133Z",
    transform: "translate(-377.426 -33.295)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6703",
    "data-name": "Group 6703",
    transform: "translate(113.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6702",
    "data-name": "Group 6702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6701",
    "data-name": "Group 6701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14647",
    "data-name": "Path 14647",
    d: "M373.723,43.133a4.919,4.919,0,1,1,4.918-4.92A4.924,4.924,0,0,1,373.723,43.133Z",
    transform: "translate(-368.805 -33.295)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6709",
    "data-name": "Group 6709",
    transform: "translate(445.302 183.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6708",
    "data-name": "Group 6708",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1566",
    "data-name": "Rectangle 1566",
    d: "M1.066,0H2.9a0,0,0,0,1,0,0V100.665a0,0,0,0,1,0,0H1.066A1.066,1.066,0,0,1,0,99.6V1.066A1.066,1.066,0,0,1,1.066,0Z",
    transform: "translate(2.898 100.665) rotate(180)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6711",
    "data-name": "Group 6711",
    transform: "translate(0 245.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6710",
    "data-name": "Group 6710",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1567",
    "data-name": "Rectangle 1567",
    d: "M1.066,0h1.94a0,0,0,0,1,0,0V63.734a0,0,0,0,1,0,0H1.066A1.066,1.066,0,0,1,0,62.668V1.066A1.066,1.066,0,0,1,1.066,0Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6713",
    "data-name": "Group 6713",
    transform: "translate(0 162.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6712",
    "data-name": "Group 6712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    d: "M1.066,0h1.94a0,0,0,0,1,0,0V63.734a0,0,0,0,1,0,0H1.066A1.066,1.066,0,0,1,0,62.668V1.066A1.066,1.066,0,0,1,1.066,0Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6715",
    "data-name": "Group 6715",
    transform: "translate(0.415 99.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6714",
    "data-name": "Group 6714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1569",
    "data-name": "Rectangle 1569",
    d: "M.948,0H2.592a0,0,0,0,1,0,0V29.634a0,0,0,0,1,0,0H.947A.947.947,0,0,1,0,28.686V.948A.948.948,0,0,1,.948,0Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6740",
    "data-name": "Group 6740",
    transform: "translate(329.223 27.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6724",
    "data-name": "Group 6724",
    transform: "translate(0 0.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6717",
    "data-name": "Group 6717",
    transform: "translate(0 6.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6716",
    "data-name": "Group 6716"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1570",
    "data-name": "Rectangle 1570",
    width: 3.036,
    height: 4.26,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6719",
    "data-name": "Group 6719",
    transform: "translate(4.945 4.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6718",
    "data-name": "Group 6718"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1571",
    "data-name": "Rectangle 1571",
    width: 3.036,
    height: 6.157,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6721",
    "data-name": "Group 6721",
    transform: "translate(9.889 2.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6720",
    "data-name": "Group 6720"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1572",
    "data-name": "Rectangle 1572",
    width: 3.036,
    height: 7.58,
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6723",
    "data-name": "Group 6723",
    transform: "translate(14.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6722",
    "data-name": "Group 6722"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1573",
    "data-name": "Rectangle 1573",
    width: 3.036,
    height: 10.332,
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6729",
    "data-name": "Group 6729",
    transform: "translate(46.381 1.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6726",
    "data-name": "Group 6726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6725",
    "data-name": "Group 6725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14649",
    "data-name": "Path 14649",
    d: "M436.952,48.465H421.7a1.094,1.094,0,0,1-1.092-1.092v-7.58a1.089,1.089,0,0,1,1.081-1.094h15.26a.281.281,0,0,1,.2.082.278.278,0,0,1,.08.2v2.5h1.634a.281.281,0,0,1,.279.279v3.652a.281.281,0,0,1-.279.281h-1.634v2.5A.278.278,0,0,1,436.952,48.465Zm-.279-9.208-14.98,0a.521.521,0,0,0-.523.533v7.58a.534.534,0,0,0,.533.533h14.97v-2.5a.28.28,0,0,1,.279-.279h1.634V42.036h-1.634a.28.28,0,0,1-.279-.279Z",
    transform: "translate(-420.611 -38.699)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6728",
    "data-name": "Group 6728",
    transform: "translate(1.802 1.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6727",
    "data-name": "Group 6727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14650",
    "data-name": "Path 14650",
    d: "M421.469,45.717V39.558h13.017v6.158Z",
    transform: "translate(-421.469 -39.558)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6739",
    "data-name": "Group 6739",
    transform: "translate(22.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6731",
    "data-name": "Group 6731",
    transform: "translate(7.24 9.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6730",
    "data-name": "Group 6730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14651",
    "data-name": "Path 14651",
    d: "M415.125,43.657a1.114,1.114,0,1,0-1.113,1.113A1.113,1.113,0,0,0,415.125,43.657Z",
    transform: "translate(-412.897 -42.542)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6738",
    "data-name": "Group 6738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6733",
    "data-name": "Group 6733",
    transform: "translate(4.555 6.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6732",
    "data-name": "Group 6732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14652",
    "data-name": "Path 14652",
    d: "M411.618,42.619l1.422,1.424a3.358,3.358,0,0,1,4.756,0l1.424-1.424a5.368,5.368,0,0,0-7.6,0Z",
    transform: "translate(-411.618 -41.042)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6735",
    "data-name": "Group 6735",
    transform: "translate(2.314 3.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6734",
    "data-name": "Group 6734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14653",
    "data-name": "Path 14653",
    d: "M416.592,39.532a8.519,8.519,0,0,0-6.041,2.507l1.422,1.424a6.522,6.522,0,0,1,9.237,0l1.424-1.424A8.523,8.523,0,0,0,416.592,39.532Z",
    transform: "translate(-410.551 -39.532)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6737",
    "data-name": "Group 6737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6736",
    "data-name": "Group 6736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14654",
    "data-name": "Path 14654",
    d: "M409.449,41.44l1.422,1.424a9.792,9.792,0,0,1,13.865,0l1.424-1.424a11.8,11.8,0,0,0-16.71,0Z",
    transform: "translate(-409.449 -37.973)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1574",
    "data-name": "Rectangle 1574",
    transform: "translate(426.484 39.411) rotate(90)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("rect", {
    width: 806.879,
    height: 404.653,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -6,
    width: 818.879,
    height: 416.653,
    rx: 30,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCase);
export default __webpack_public_path__ + "static/media/phone-case.4d92c442140f8994a29e36e672f3ab3f.svg";
export { ForwardRef as ReactComponent };